import React, {useState} from 'react';
import { useMainStateMachine, useMainState } from "../MainStateMachineProvider";
import { machine as m } from "../../constants/machine.constants";
import { Modal, CheckBox } from "../../index";
import { CounterManager } from "../CounterManager/CounterManager";
import css from "./ScenarioSettingsModal.module.css";

const ScenarioSettingsModal = ({ isVisible, onClose }) => {
    const { send } = useMainStateMachine();
    const state = useMainState();
    const [isSave, setIsSave] = useState(false); // Mode toggle here
    const { 
        studyLang, 
        baseLang, 
        availableLangs, 
        currentItem,
        leftRepeats,
        stepDelay
    } = state.context;

    if (!isVisible) return null;

    // Settings for Voice Repeats (if current item is sound)
    const repeatSettings = {
        local: { name: "repeats", value: currentItem?.props?.repeats || 0 },
        global: { name: "leftRepeats", value: leftRepeats || 0 }
    };

    // Settings for Delay (Pause or Sound delay)
    const delaySettings = {
        local: { name: "delay", value: currentItem?.props?.delay || 0 },
        global: { name: "stepDelay", value: stepDelay || 0 }
    };

    const changeCount = (settings) => (type) => {
        const guard = isSave; // Use modal state
        const payload = guard ? settings.local : settings.global;
        if (type === "inc") {
            send({ type: m.events.INCREMENT, data: { payload, guard } });
        } else {
            send({ type: m.events.DECREMENT, data: { payload, guard } });
        }
    };


    const handleLangChange = (role, value) => {
        let newStudy = role === 'study' ? value : studyLang;
        let newBase = role === 'base' ? value : baseLang;
        // Ensure they are not the same if possible
        if (newStudy === newBase && availableLangs.length > 1) {
            const alternative = availableLangs.find(l => l !== value);
            if (role === 'study') newBase = alternative;
            else newStudy = alternative;
        }

        send({
            type: m.events.SET_LANGS,
            studyLang: newStudy,
            baseLang: newBase
        });
    };

    // Filtered lists for dropdowns
    const studyOptions = availableLangs;
    const baseOptions = availableLangs.filter(l => l !== studyLang || availableLangs.length === 1);

    return (
        <Modal isVisible={isVisible} onClose={onClose}>
            <div className={css.settingsContainer}>
                <h3>Налаштування сценарію</h3>

                <section className={css.section}>
                    <h4>Мови</h4>
                    <div className={css.field}>
                        <label>Вивчаю (Study):</label>
                        <select 
                            value={studyLang} 
                            onChange={(e) => handleLangChange('study', e.target.value)}
                        >
                            {studyOptions.map(lang => (
                                <option key={lang} value={lang}>{lang}</option>
                            ))}
                        </select>
                    </div>
                    <div className={css.field}>
                        <label>Рідна (Base):</label>
                        <select 
                            value={baseLang} 
                            onChange={(e) => handleLangChange('base', e.target.value)}
                        >
                            {baseOptions.map(lang => (
                                <option key={lang} value={lang}>{lang}</option>
                            ))}
                        </select>
                    </div>
                </section>

                {currentItem && (currentItem.type === 'sound' || currentItem.type === 'pause') && (
                    <section className={css.section}>
                        <h4>Параметри кроку ({currentItem.type})</h4>
                        
                        <div className={css.modeToggle}>
                            <CheckBox checked={isSave} onChange={() => setIsSave(!isSave)}>
                                Зберігати зміни в сценарій (назавжди)
                            </CheckBox>
                        </div>

                        <div className={css.counters}>
                            {currentItem.type === 'sound' && (
                                <div className={css.field}>
                                    <label>Повтори:</label>
                                    <CounterManager
                                        count={isSave ? repeatSettings.local.value : repeatSettings.global.value}
                                        onIncrement={() => changeCount(repeatSettings)('inc')}
                                        onDecrement={() => changeCount(repeatSettings)('dec')}
                                        onAction={() => {}}
                                        isActive={true}
                                    />
                                </div>
                            )}
                            <div className={css.field}>
                                <label>Затримка (сек):</label>
                                <CounterManager 
                                    count={isSave ? delaySettings.local.value : delaySettings.global.value}
                                    onIncrement={() => changeCount(delaySettings)('inc')}
                                    onDecrement={() => changeCount(delaySettings)('dec')}
                                    onAction={() => {}}
                                    isActive={true}
                                />
                            </div>
                        </div>
                    </section>
                )}
                
                <button className={css.closeBtn} onClick={onClose}>Закрити</button>
            </div>
        </Modal>
    );
};

export { ScenarioSettingsModal };